import {HttpAxiosRequest} from "../../../../../http/httpAxiosBase";
import {OperacionCapitalMarketsDetalle, schemaOperacionCapitalMarketsDetalle} from "../types/types";
import {BaseResponse} from "../../../../../types";
import {
  OperacionCapitalMarketsInsertDTO,
  OperacionCapitalMarketsUpdateDTO,
  OperacionCapitalMarketsViewDTO,
  schemaCapitalMarketsInsert,
  schemaFormCapitalMarketsUpdate,
  schemaOperacionCapitalMarketsView
} from "../types/dto";
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";

export const getEndpoint = (url = '') => `operaciones/capital-markets${url}`

export const HttpCapitalMarkets = {
  get: (idOperacion: number): Promise<OperacionCapitalMarketsViewDTO> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
      .then(response => {
        const parsed = schemaOperacionCapitalMarketsView.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
  put: (idOperacion: number, operacion: OperacionCapitalMarketsUpdateDTO): Promise<BaseResponse> => {
    const parsed = schemaFormCapitalMarketsUpdate.safeParse(operacion)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}`), parsed.data) // TODO: parsed.data, no operacion
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
  post: (operacion: OperacionCapitalMarketsInsertDTO): Promise<BaseResponse> => {
    const parsed = schemaCapitalMarketsInsert.safeParse(operacion)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.post(getEndpoint(), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
  getDetalle: (idOperacion: number): Promise<OperacionCapitalMarketsDetalle> => {
    return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}/detalles`))
      .then(response => {
        const parsed = schemaOperacionCapitalMarketsDetalle.safeParse(response)

        if (!parsed.success) {
          console.error('Error de validación:', parsed.error.issues)

          return Promise.reject(new Error('Error de validación.'))
        }

        return parsed.data
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
  putDetalle: (idOperacion: number, idOperacionDetalle: number, detalle: OperacionCapitalMarketsDetalle): Promise<BaseResponse> => {
    const parsed = schemaOperacionCapitalMarketsDetalle.safeParse(detalle)

    if (!parsed.success) {
      console.error('Error de validación:', parsed.error.issues)

      return Promise.reject(new Error('Error de validación.'))
    }

    return HttpAxiosRequest.put(getEndpoint(`/${idOperacion}/detalles/${idOperacionDetalle}`), parsed.data)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(error => {
        console.error('Error de red:', error)

        return Promise.reject('Error de red.')
      })
  },
  descargarInforme: (idOperacion: number): Promise<any> =>
      HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.CapitalMarkets),
}